const fieldTypes = {
  master: true,
  intAsString: true,
  epoch: true,
  string: true,
  enum: true,
  boolean: true
}

// DUTY ITEM FIELDS
export const DoMFields = {
  countryOfOrigin: {
    label: '',
    apiKey: '',
    type: fieldTypes,
    required: true,
    rules: [
      {
        test: value => {
          return value !== null && value !== ''
        },
        message: 'Field must not be empty'
      }
    ]
  },
  productClaimCode: {
    label: '',
    apiKey: '',
    type: fieldTypes,
    required: true,
    rules: [
      {
        test: value => {
          return value !== null && value !== ''
        },
        message: 'Field must not be empty'
      }
    ]
  },
  mid: {
    label: '',
    apiKey: '',
    type: fieldTypes,
    required: true,
    rules: [
      {
        test: value => {
          return value !== null && value.trim() !== ''
        },
        message: 'Field must not be empty'
      }
    ],
    validate: () => {},
    updateValue: () => {},
    saveValue: () => {}
  },
  "grossWeight.weight": {
    label: '',
    apiKey: '',
    type: fieldTypes,
    required: true,
    rules: [
      {
        test: value => {
          if(typeof value=="object"){
            return true;
          }
          return  !!value && value.trim() !== '' && parseFloat(value)!==0
        },
        message: 'Field must not be empty or zero'
      }
    ],
    validate: () => {},
    updateValue: () => {},
    saveValue: () => {}
  },
  otherFee: {
    label: '',
    apiKey: '',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== null
        },
        message: 'Field must not be empty'
      }
    ],
    errors: [],
    valid: false,
    validate: () => {},
    updateValue: () => {},
    saveValue: () => {}
  },
  mpfRate: {
    label: '',
    apiKey: '',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== null
        },
        message: 'Field must not be empty'
      }
    ],
    errors: [],
    valid: false,
    validate: () => {},
    updateValue: () => {},
    saveValue: () => {}
  },
  mpfFee: {
    label: '',
    apiKey: '',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== null
        },
        message: 'Field must not be empty'
      }
    ],
    errors: [],
    valid: false,
    validate: () => {},
    updateValue: () => {},
    saveValue: () => {}
  },
  hmfRate: {
    label: '',
    apiKey: '',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== null
        },
        message: 'Field must not be empty'
      }
    ],
    errors: [],
    valid: false,
    validate: () => {},
    updateValue: () => {},
    saveValue: () => {}
  },
  hmfFee: {
    label: '',
    apiKey: '',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== null
        },
        message: 'Field must not be empty'
      }
    ],
    errors: [],
    valid: false,
    validate: () => {},
    updateValue: () => {},
    saveValue: () => {}
  },
  IRTax: {
    label: '',
    apiKey: '',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== null
        },
        message: 'Field must not be empty'
      }
    ],
    errors: [],
    valid: false,
    validate: () => {},
    updateValue: () => {},
    saveValue: () => {}
  }
}

// LINE TIEM FIELDS
export const DutyItemFields = {
  htsus: {
    label: '',
    apiKey: '',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== null && value !== ''
        },
        message: 'Field must not be empty'
      }
    ],
    errors: [],
    valid: false,
    validate: () => {},
    updateValue: () => {},
    saveValue: () => {}
  },
  manifestQuantityNum: {
    label: '',
    apiKey: '',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== null
        },
        message: 'Field must not be empty'
      }
    ],
    errors: [],
    valid: false,
    validate: () => {},
    updateValue: () => {},
    saveValue: () => {}
  },
  manifestQuantityUnits: {
    label: '',
    apiKey: '',
    rules: [
      {
        test: value => {
          return value !== null
        },
        message: 'Field must not be empty'
      }
    ],
    errors: [],
    valid: false,
    required: true,
    validate: () => {},
    updateValue: () => {},
    saveValue: () => {}
  },
  additionalQuantityNum: {
    label: '',
    apiKey: '',
    rules: [
      {
        test: value => {
          return value !== null
        },
        message: 'Field must not be empty'
      }
    ],
    errors: [],
    valid: false,
    required: true,
    validate: () => {},
    updateValue: () => {},
    saveValue: () => {}
  },

  additionalQuantityUnits: {
    label: '',
    apiKey: '',
    rules: [
      {
        test: value => {
          return value !== null
        },
        message: 'Field must not be empty'
      }
    ],
    errors: [],
    valid: false,
    required: true,
    validate: () => {},
    updateValue: () => {},
    saveValue: () => {}
  },
  enteredValue: {
    label: '',
    apiKey: '',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== null
        },
        message: 'Field must not be empty'
      }
    ],
    errors: [],
    valid: false,
    validate: () => {},
    updateValue: () => {},
    saveValue: () => {}
  },
  dutyRate: {
    label: '',
    apiKey: '',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== null
        },
        message: 'Field must not be empty'
      }
    ],
    errors: [],
    valid: false,
    validate: () => {},
    updateValue: () => {},
    saveValue: () => {}
  },
  duty: {
    label: '',
    apiKey: '',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== null
        },
        message: 'Field must not be empty'
      }
    ],
    errors: [],
    valid: false,
    validate: () => {},
    updateValue: () => {},
    saveValue: () => {}
  }
}
